module.exports = __webpack_public_path__ + "media/images/icons/icon_user-7305ad6f62b1e96234f0cdcefaedfc39.svg";